<template>
  <div>

    <vx-card card-border class="mb-4" title="Dirección de la instalación" title-color="dark" collapseAction>
      <div class="vx-row mb-2">
        <div class="vx-col sm:w-1/2 w-full">
          <div>
            <span>Dirección</span>
          </div>
          <div>
            <vs-input class="w-full" v-model="direccionInstalacion.direccion" disabled/>
          </div>
        </div>
        <div class="vx-col sm:w-1/12 w-full">
          <div>
            <span>Núm.</span>
          </div>
          <div>
            <vs-input class="w-full" v-model="direccionInstalacion.numero" disabled/>
          </div>
        </div>
        <div class="vx-col sm:w-1/12 w-full">
          <div>
            <span>Portal</span>
          </div>
          <div>
            <vs-input class="w-full" v-model="direccionInstalacion.portal" disabled/>
          </div>
        </div>
        <div class="vx-col sm:w-1/12 w-full">
          <div>
            <span>Escalera</span>
          </div>
          <div>
            <vs-input class="w-full" v-model="direccionInstalacion.escalera" disabled/>
          </div>
        </div>
        <div class="vx-col sm:w-1/12 w-full">
          <div>
            <span>Planta</span>
          </div>
          <div>
            <vs-input class="w-full" v-model="direccionInstalacion.planta" disabled/>
          </div>
        </div>
        <div class="vx-col sm:w-1/12 w-full">
          <div>
            <span>Puerta</span>
          </div>
          <div>
            <vs-input class="w-full" v-model="direccionInstalacion.puerta" disabled/>
          </div>
        </div>
      </div>
      <div class="vx-row mb-2">
        <div class="vx-col sm:w-1/2 w-full">
          <div>
            <span>Localidad</span>
          </div>
          <div>
            <vs-input class="w-full" v-model="direccionInstalacion.localidad" disabled/>
          </div>
        </div>
        <div class="vx-col sm:w-1/2 w-full">
          <div>
            <span>Municipio</span>
          </div>
          <div>
            <select-val-municipio class="w-full" name="municipio" v-model="direccionInstalacion.municipio" :municipioSelected="direccionInstalacion.municipio" disabled/>
          </div>
        </div>
      </div>
      <div class="vx-row mb-2">
        <div class="vx-col sm:w-2/12 w-full">
          <div>
            <span>Cód. Postal</span>
          </div>
          <div>
            <vs-input class="w-full" v-model="direccionInstalacion.cp" disabled/>
          </div>
        </div>
        <div class="vx-col sm:w-4/12 w-full">
          <div>
            <span>Provincia</span>
          </div>
          <div>
            <select-val-provincia class="w-full" v-model="direccionInstalacion.provincia" :provinciaSelected="direccionInstalacion.provincia" disabled/>
          </div>
        </div>
        <div class="vx-col sm:w-6/12 w-full">
          <div>
            <span>Pais</span>
          </div>
          <div>
            <vs-input class="w-full" v-model="direccionInstalacion.pais" disabled/>
          </div>
        </div>
      </div>
    </vx-card>

    <!-- Save & Reset Button -->
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="mt-8 flex flex-wrap items-center justify-end">
        <vs-button class="ml-4 mt-2" type="border" color="warning" @click="reset_data">Volver</vs-button>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import operacionesStore from '@/store/gestion/operaciones/index.js'

import selectValMunicipio from '@/views/common-components/selectValMunicipio'
import selectValProvincia from '@/views/common-components/selectValProvincia'

export default {
  name: 'OperacionesEditDireccion',
  components: {
    selectValMunicipio,
    selectValProvincia
  },
  data () {
    return {
      operacion: {},
      direccionInstalacion: {},
      direccionInstalacionId: null,
      cliente: {},
      direccionCliente: {},
      direccionClienteId: null,
      direccionInstalacionDisabled: false
    }
  },
  computed: {},
  methods: {
    reset_data () {
      this.$router.push({name: 'operaciones'})
    }
  },
  created () {
    if (!operacionesStore.isRegistered) {
      this.$store.registerModule('operacionesStore', operacionesStore)
      operacionesStore.isRegistered = true
    }

    this.operacion = JSON.parse(JSON.stringify(this.$store.state.operacionesStore.operacion))
    this.direccionInstalacion = JSON.parse(JSON.stringify(this.$store.state.operacionesStore.operacion.direccion))
  }
}
</script>

